export const lang = {
  language: '简体中文',
  yes: '确定',
  no: '取消',
  yes1: 'yes',
  no1: 'no',
  tip: '提示',
  tips: 'Tips',
  languageTip: '你确定要换成中文吗？',
  conferenceTime: 'Deadline for registration',
  conferencePlace: 'Venue',
  conferenceIntroduction: 'Agenda',
  conferenceTheme: 'Theme',
  conferenceNews: 'Information',
  introductionOfExperts: 'Keynote Speakers',
  conferenceCallForPapers: 'Call for Proposal',
  registration: 'Registration',
  questionnaire: 'Survey',
  register: 'Register now',
  agenda: 'Agenda',
  more: 'More',
  themes: 'Themes',
  deadline: 'Deadline',
  guidelines: 'General Guidelines',
  paperReview: 'Proposal review',
  submitPaper: 'Submit the Proposal',
  submitPersonalPaper: 'Submit the personal Proposal',
  submitorGanizationPaper: 'Submit the organization Proposal',
  certificate: 'Getting your certificate of Proposal acceptance',
  query: 'My information',
  modify: 'Modify information（Upload payment voucher）',
  pay: 'Fees & Payment',
  refund: 'Cancellation policy & Refund',
  signIn: 'Check in',
  sign: 'Check in',
  invoice: 'Invoice',
  confirmationInformation: 'Please fill out your information below and click Confirm to continue',
  name: 'Full name',
  nameOfParticipant: 'Full name of participant',
  nameHint: 'Please enter your name',
  cannotBeEmpty: 'This option cannot be empty~',
  nameCannotBeEmpty: 'Full name cannot be empty~',
  phone: 'Phone number',
  phoneOfParticipant: 'Email of participant',
  phoneCannotBeEmpty: 'Phone number cannot be empty~',
  correctPhone: 'Please input the correct phone number~',
  emailCannotBeEmpty: 'Email cannot be empty~',
  correctEmail: 'Please input the correct email~',
  idsCannotBeEmpty: 'Passport No. cannot be empty~',
  correctIds: 'Please input the correct ID~',
  confirm: 'Confirm',
  excellent: 'Excellent',
  good: 'Good',
  average: 'Average',
  unsatisfactory: 'Poor/Unsatisfactory',
  selectAtLeastOne: 'Please select at least one item~',
  submittedSuccessfully: 'Submitted successfully',
  submit: 'Submit',
  reSubmit: 'Resubmit ',
  close: 'Close',
  note: 'Guide for Registration',
  understandNextStep: 'Understand and agreed to go to the next step',
  nonMembers: 'Non-members:',
  individualMember: 'Individual member:',
  organizationMember: 'Organization member:',
  hotelExpense: 'RMB,hotel expense:',
  rmb: 'RMB',
  rmbPerson: 'RMB/Person ',
  next: 'Next',
  back: 'Back',
  email: 'E-mail',
  required: 'Note: fields with * are required, please fill in truthfully.',
  needHotel: 'Do you need to reserve a hotel room？',
  selectHotels: 'Select hotels',
  reservation: 'Click here to make a reservation',
  china: 'China',
  otherCountry: 'Other country',
  otherCountryName: 'Fill in the country name',
  phoneOrEmail: 'Email',
  phoneOrEmailHint: 'Please enter email address',
  phoneOrEmailCannotBeEmpty: 'Email address cannot be empty~',
  correctPhoneOrEmail: 'Please input the correct Email address~',
  authentication: 'Authentication',
  login: 'Login',
  cancel: 'Cancel',
  registrationNumber: 'Conference registration number',
  conferencTopics: 'Name of Conference',
  participant: 'Participant',
  registrationPhoneOrEmail: 'Email address of the participant',
  status: 'Application status',
  status2: 'Status',
  submissionTime: 'Submission time',
  paymentStatus: 'Payment status',
  download: 'Download',
  preview: 'Preview',
  location: 'Location',
  companyName: 'Organization unit name',
  companyCannotBeEmpty: 'Organization unit name cannot be empty~',
  ids: 'Passport No.',
  documentTitle: 'Title',
  documentTitleCannotBeEmpty: 'Title cannot be empty~',
  authorName: 'Author(s)',
  authorNameCannotBeEmpty: 'Author(s) cannot be empty~',
  classification: 'Sub-themes',
  uploadDocument: 'Submission upload',
  uploadDocumentTips: 'Please upload your submissions in the format of either doc or docx. The maximum size of a single file is 30 MB.',
  uploadDocumentTips2: 'Please upload the Proposal or picture in the "Submission upload" section',
  verificationCode: 'Captcha',
  verificationCodeHint: 'Please enter captcha',
  getVerificationCode: 'Get captcha',
  agree: 'By clicking the button, you agree to the above rules',
  submitTime: 'Submit time',
  attachFile: 'Attach file',
  downloadCertificate: 'Download award certificate',
  queryAwardResults: 'My Proposal information',
  individualMemberVerification: 'Individual member verification',
  organizationMemberVerification: 'Organization member verification',
  ids2: 'Passport No.',
  teamName: 'University/Company/Organization',
  organizationCode: 'Organization code or unified social credit code',
  signAgain: 'Please re-enter the sign-in information',
  Information: 'Information ',
  verificationSuccessful: 'verification is successful',
  staffVerification: ', please DO NOT click the "Confirm"button before you confirm with on-site staff.',
  ConferencePass: 'Conference pass',
  Organization: 'Organization',
  SignInTime: 'Sign in time',
  staff: 'Please confirm with the on-site staff',
  warmPrompt: 'Warm prompt：',
  Confirmed: 'Confirmed! You can attend the conference.'
}
